export default __webpack_public_path__ + "static/media/video-exercise.c305b0a4.png";